import { render, staticRenderFns } from "./sample_component.vue?vue&type=template&id=0c9221d1"
import script from "./sample_component.vue?vue&type=script&lang=js"
export * from "./sample_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports